import CryptoJS from "crypto-js";
export const Per_Page_Dropdown = async (data) => {
  const a = [];
  for (let i = 5; i <= data; i *= 2) {
    a.push(i);
  }
  a.push(data);
  // console.log(a);

  return a;
};

export const ImageValidation = {
  files_type: ["jpg", "png", "jpeg"],
  product: { w: 578, h: 762 },
};

export const RequiredIs = {
  roles: [1],
  service_term: [1, 2, 3, 4],
  service_type: [1, 2, 3],
  product_type: [1, 2, 3, 4],
};

export const Select2Data = async (data, name, other = false) => {
  const result = data?.map((data) => ({
    value: data?.id,
    label: data?.name,
    name: name,
  }));

  if (other) {
    result.push({ value: "0", label: "Other", name: name });
  }
  return result;
};

export const getDimension = async (file) => {
  let reader = new FileReader();
  return new Promise((resolve, reject) => {
    reader.onerror = () => {
      reader.abort();
      reject(new DOMException("Problem parsing input file."));
    };

    reader.onload = () => {
      var image = new Image();
      image.src = reader.result;
      image.onload = function () {
        resolve({ width: this.width, height: this.height });
      };
    };
    reader.readAsDataURL(file);
  });
};

export function formatDate(dateString) {
  const date = new Date(dateString);
  return date.toISOString().split("T")[0];
}
export const formatTime = (time) => {
  if (!time) return "";

  const [hours, minutes] = time.split(":");
  const date = new Date();
  date.setHours(hours);
  date.setMinutes(minutes);

  return date.toLocaleTimeString("en-IN", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
};
export const RegxExpression = {
  name: /[A-Z-a-z ]/,
  email:
    /^([A-Za-z0-9_\-\.])+\@(?!(?:[A-Za-z0-9_\-\.]+\.)?([A-Za-z0-9_\-\.]+)\.\2)([A-Za-z0-9_\-\.]+\.)+([A-Za-z]{2,4})$/,
  phone: /[0-9]/,

  ifsc: "^[A-Z]{4}[0][dA-Z]{6}$",
  ifsc_code: /^[A-Z0-9]$/,
  micr: /^[0-9]{9}$/,
  bank_number: /^\d{0,14}$/,
  gst: /^\d{2}[A-Z]{5}\d{4}[A-Z]{1}[1-9A-Z]{1}[Z]{1}[1-9A-Z]{1}$/,
};

export const formatViews = (views = 0) => {
  if (views < 1_000) {
    return views.toLocaleString();
  }

  if (views < 1_000_000) {
    return (views / 1_000).toFixed(1).replace(".0", "") + "K";
  }

  if (views < 1_000_000_000) {
    return (views / 1_000_000).toFixed(1).replace(".0", "") + "M";
  }

  return (views / 1_000_000_000).toFixed(1).replace(".0", "") + "B";
};

const SECRET_KEY = "INFINITYLADAKH";
export const encodeId = (id) => {
  if (!id) return "";
  const ciphertext = CryptoJS.AES.encrypt(id.toString(), SECRET_KEY).toString();
  return encodeURIComponent(ciphertext); // Make URL-safe
};

export const decodeId = (encodedId) => {
  if (!encodedId) return "";
  try {
    const decoded = decodeURIComponent(encodedId);
    const bytes = CryptoJS.AES.decrypt(decoded, SECRET_KEY);
    return bytes.toString(CryptoJS.enc.Utf8);
  } catch (error) {
    console.error("Invalid ID decryption:", error);
    return error;
  }
};


export const IDS = {
  Role: { List: 1, Add: 2, Edit: 3, Delete: 4 },
  User: { List: 5, Add: 6, Edit: 7, Delete: 8 },
  Country: { List: 9, Add: 10, Edit: 11, Delete: 12 },
  State: { List: 13, Add: 14, Edit: 15, Delete: 16 },
  City: { List: 17, Add: 18, Edit: 19, Delete: 20 },
  Pincode: { List: 21, Add: 22, Edit: 23, Delete: 24 },
  CountryCode: { List: 25, Add: 26, Edit: 27, Delete: 28 },
  Category: { List: 29, Add: 30, Edit: 31, Delete: 32 },
  SubCategory: { List: 33, Add: 34, Edit: 35, Delete: 36 },
  HomeBanner: { List: 37, Add: 38, Edit: 39, Delete: 40 },
  HomeMotivatedBy: { List: 41, Add: 42, Edit: 43, Delete: 44 },
  FAQList: { List: 45, Add: 46, Edit: 47, Delete: 48 },
  // AddOn: { List: 49, Add: 50, Edit: 51, Delete: 52 },
  // AdditionalSupport: { List: 53, Add: 54, Edit: 55, Delete: 56 },
  BookingCancelReason: { List: 57, Add: 58, Edit: 59, Delete: 60 },
  WhyFNS: { List: 61, Add: 62, Edit: 63, Delete: 64 },
  WhyChoose: { List: 65, Add: 66, Edit: 67, Delete: 68 },
  OurVissionMission: { List: 69, Add: 70, Edit: 71, Delete: 72 },
  AppSetup: { List: 73, Add: 74, Edit: 75, Delete: 76 },
  SocialMedia: { List: 77, Add: 78, Edit: 79, Delete: 80 },
  HomeAboutUs: { List: 83, Add: 84, Edit: 85, Delete: 86 },
  OurTeam: { List: 87, Add: 88, Edit: 89, Delete: 90 },
  PrivacyPolicy: { List: 91, Add: 92, Edit: 93, Delete: 94 },
  TermsConditions: { List: 95, Add: 96, Edit: 97, Delete: 98 },
  Packages: { List: 99, Add: 100, Edit: 101, Delete: 102 },
  // Special: { List: 126, Add: 127, Edit: 128, Delete: 129 },
  LocalPackages: { List: 103, Add: 104, Edit: 105, Delete: 106 },
  ContactUs: { List: 114 },
  Enquiry: { List: 118 },

  Booking: { List: 132, StatusChange: 133 },
  BookingCancel: { List: 136 },



  cab_type: { List: 144, Add: 145, Edit: 146, Delete: 147 },
  cab_fare: { List: 149, Add: 150, Edit: 151, Delete: 152 },
  cuppon_codes: { List: 153, Add: 154, Edit: 155, Delete: 156 },
  categories_route: { List: 158, Add: 159, Edit: 160, Delete: 161 },
  sub_category_route: { List: 163, Add: 164, Edit: 165, Delete: 166 },
  subscription: { List: 168, Add: 169, Edit: 170, Delete: 171 },
  subscription_history: { List: 172 },
  fuel_type: { List: 173, Add: 174, Edit: 175, Delete: 176 },
  seat_capacity: { List: 177, Add: 178, Edit: 179, Delete: 180 },
  reasons_cancellation: { List: 181, Add: 182, Edit: 183, Delete: 184 },
  cancellation_policy: { List: 186, Add: 187, Edit: 188, Delete: 189 },
  blog_category: { List: 191, Add: 192, Edit: 193, Delete: 194 },
  blog: { List: 196, Add: 197, Edit: 198, Delete: 199 },
  driver: { List: 201 },
  employee: { List: 202, Add: 203, Edit: 204, Delete: 205 },
  happy_customer: { List: 206, Add: 207, Edit: 208, Delete: 209 },
  why_ride: { List: 210, Add: 211, Edit: 212, Delete: 213 },
  key_services: { List: 214, Add: 215, Edit: 216, Delete: 217 },
  banner: { List: 218, Add: 219, Edit: 220, Delete: 221 },
  disclaimer: { List: 222, Add: 223, Edit: 224, Delete: 225 },
  cancellation_charages: { List: 226 },
  ContactSupport: { List: 227, Add: 228, Edit: 229, Delete: 230 },
  CustomerDetails: { List: 130 },
  PackageBookRequest: { List: 123 },
  FraudUser: { List: 122 },
  ContactUs: { List: 114 },
  walleteHistory: { List: 115 },
  BulkUpload: {
    Country: 107,
    State: 108,
    City: 109,
    Pincode: 110,
    CountryCode: 111,
    Category: 112,
    SubCategory: 113,
    cab_type: 143,
    cab_fare: 148,
    cuppon_codes: 157,
    categories_route: 162,
    sub_category_route: 167,
    reasons_cancellation: 185,
    cancellation_policy: 190,
    blog_category: 195,
    blog: 200,
  },
};
